// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__24M3H","disabled":"Button_disabled__2XdLE","loader":"Button_loader__3oVMg","visible":"Button_visible__y4Qcp"};